// Clave en localStorage de «ya vio la bienvenida de la prueba», por negocio (H61).
// Antes el modelo Business no guardaba el id y la clave quedaba en «anon» para todos.
export function trialWelcomeKey(business) {
    const id = business && business.id;
    return `contablus.trialWelcome.${id || 'anon'}`;
}
